import { useMutation } from 'react-query';
import { stripeError } from 'Core/utils/stripe';

export default function useConfirmSetup() {
  return useMutation(async ({ stripe, elements, returnUrl, billingDetails }) => {
    const confirmParams = { return_url: returnUrl };
    if (billingDetails) {
      confirmParams.payment_method_data = { billing_details: billingDetails };
    }
    const { error, setupIntent } = await stripe.confirmSetup({
      elements,
      confirmParams,
      redirect: 'if_required',
    });
    if (error) {
      throw stripeError(error);
    }
    return { status: setupIntent?.status };
  });
}
